/**
 * Inject CSS class into figure tag when iframes are utilized
 * to provide missing context to render captioned videos correctly
 * Drupal lacks the ability to provide this context with captions
 */

(function ($, Drupal) {
  $("iframe.media-oembed-content").each(function() {
    $(this).closest("figure").addClass("figure__video");
    // add class to non-captioned videos for better styling context
    $(this).closest("div.align-center, div.align-left, div.align-right").addClass("video--no-caption");
  })
}(jQuery, Drupal));
